import { useEffect } from "react";

export const useDocumentTitle = (title) => {
    useEffect(() => {
        document.title = `NKFinance - ${title}`;
    }, [title]);

    return null;
}
